"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _paymentType = require("@/types/paymentType");
var PaymentOrderForm = /*#__PURE__*/function (_Vue) {
  function PaymentOrderForm() {
    var _this;
    (0, _classCallCheck2.default)(this, PaymentOrderForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, PaymentOrderForm, [].concat(args));
    (0, _defineProperty2.default)(_this, "orderProgress", void 0);
    (0, _defineProperty2.default)(_this, "form", void 0);
    (0, _defineProperty2.default)(_this, "disabled", void 0);
    (0, _defineProperty2.default)(_this, "compare", void 0);
    (0, _defineProperty2.default)(_this, "rules", {});
    (0, _defineProperty2.default)(_this, "PaymentType", _paymentType.PaymentType);
    (0, _defineProperty2.default)(_this, "PaymentStatus", _paymentType.PaymentStatus);
    return _this;
  }
  (0, _inherits2.default)(PaymentOrderForm, _Vue);
  return (0, _createClass2.default)(PaymentOrderForm, [{
    key: "remainAmount",
    get: function get() {
      return this.form.totalPrice - this.orderProgress.paymentAmount;
    }
  }, {
    key: "handleChangePaymentStatus",
    value: function handleChangePaymentStatus() {
      if (this.orderProgress.paymentStatus == _paymentType.PaymentStatus.Complete) {
        this.orderProgress.paymentAmount = this.form.totalPrice;
      } else {
        this.orderProgress.paymentAmount = 0;
      }
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], PaymentOrderForm.prototype, "orderProgress", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  required: true
})], PaymentOrderForm.prototype, "form", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], PaymentOrderForm.prototype, "disabled", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], PaymentOrderForm.prototype, "compare", void 0);
PaymentOrderForm = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], PaymentOrderForm);
var _default = exports.default = PaymentOrderForm;